import { Container, Row } from 'react-bootstrap';
import logo from '../assets/images/logo.png';

export default function DocumentationLayout({ children }) {
    const heading = window.location.pathname
        .substring(1)
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    return (
        <div fluid style={{ overflow: 'scrollable', padding: 0 }}>
            <div className="main-background p-5">
                <Container fluid>
                    <Row>
                        <img src={logo} className="logo" alt="logo" />
                    </Row>
                    <div className="text-center">
                        <h3 style={{ color: 'white' }}>{heading}</h3>
                    </div>
                </Container>
            </div>
            {children}
        </div>
    );
}
